import * as React from "react";

interface TopMessagesConsumerInterface {
  topMessage: string | null;

  handleCloseTopMessage: () => void;
}

const defaultValue = {} as unknown as TopMessagesConsumerInterface;

const TopMessagesContext = React.createContext(defaultValue);

export const TopMessagesProvider: React.FunctionComponent = (props) => {
  const [hasInitialized, setHasInitialized] = React.useState(false);

  const [topMessage, setTopMessage] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!hasInitialized) {
      acquireTopMessagesFromTheUrl();
      cleanTopMessagesFromTheUrl();

      setHasInitialized(true);
    }
  }, [hasInitialized]);
  React.useEffect(() => {
    let timeoutReference: number | null = null;
    if (topMessage) {
      timeoutReference = window.setTimeout(() => {
        setTopMessage(null);
      }, 10000);
    }
    return () => {
      if (timeoutReference) {
        window.clearTimeout(timeoutReference);
      }
    };
  }, [topMessage]);

  const acquireTopMessagesFromTheUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const change_password_success = urlParams.get("change_password_success");
    if (change_password_success === "true") {
      setTopMessage("Your password has been successfully reset.");
    }
  };
  const cleanTopMessagesFromTheUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("change_password_success");
    window.history.replaceState({}, "", url.href);
  };

  const handleCloseTopMessage = () => {
    setTopMessage(null);
  };

  return (
    <TopMessagesContext.Provider
      value={{
        topMessage,
        handleCloseTopMessage,
      }}
    >
      {props?.children || []}
    </TopMessagesContext.Provider>
  );
};

export const useTopMessages = () => {
  const context = React.useContext(TopMessagesContext);
  if (context === defaultValue) {
    throw new Error("useTopMessages must be used within a TopMessagesProvider");
  }
  return context;
};
